import type {IPrice, IProduct, IProductVariant} from './Show'

export enum BidState {
    pending = 'pending',
    confirmed = 'confirmed',
    denied = 'denied',
}

export interface IBidData {
    id: string
    showId: number
    productId: string
    variantId: string
    state: BidState
    priceCent: number
    finalPriceCent: number|null
    hasTracked: boolean
    material?: string
    ringsize?: string
}

export interface IBid {
    id: string
    showId: number
    product: IProduct
    variant: IProductVariant
    state: BidState
    bidPrice: IPrice
    finalPrice?: IPrice
    hasTracked: boolean
    allowNotify: boolean
    notified: boolean
}

export enum NotificationType {
    confirmation = 'confirmation',
    rejection = 'rejection',
    neutral = 'neutral',
}

export interface INotification {
    type: NotificationType
    title: string
    message?: string
    message2?: string
    imagePath?: string
    durationMs: number
    id?: string // only used internally
}

export interface IUser {
    authenticated: boolean
    bidReady: boolean
    hasBidBefore: boolean
    token: string|null
    uuid: string|null
}

export enum ButtonState {
    placeBid = 'placeBid',
    pleaseWait = 'pleaseWait',
    confirmBid = 'confirmBid',
    bidSuccessful = 'bidSuccessful',
    chooseVariant = 'chooseVariant',
    variantSold = 'variantSold',
    productSold = 'productSold',
    loginAndBid = 'loginAndBid',
    completeBidData = 'completeBidData',
    addToCart = 'addToCart',
    none = 'none',
}

export enum AgentPanel {
    show = 'show',
    login = 'login',
    register = 'register',
    completeData = 'completeData',
}

// these values must correspond with Juwelo_Fuse_Helper_Customer::BIDAGENT_PAYMENT_* values from php
export enum PaymentType {
    cashOnDelivery = 'cash on delivery',
    creditCard = 'creditcard',
    prePayment = 'prepay',
}